export default __webpack_public_path__ + "static/media/connections_settings.253ed581.png";